import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    superAdminDashboardIndex: [],
    superAdminDashboardOrderMetrics:{},
    superAdminDashboardSalesMetrics:{}
};

const superAdminDashboard = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SUPER_ADMIN_DASHBOARD_INDEX_LIST: {
        const superAdminDashboardIndexArr = Object.entries(payload?.superAdminDashboardIndex).reduce((accumulator, [key, value])=>{
            const tempKey = key[0].toUpperCase() + key.substring(1);
            accumulator.push({key:tempKey, value})
            return accumulator
        },[])
      draft.superAdminDashboardIndex = superAdminDashboardIndexArr;
      break;
    }

    case Actions.GET_SUPER_ADMIN_DASHBOARD_ORDER_METRICS_LIST: {
        draft.superAdminDashboardOrderMetrics = payload?.superAdminDashboardOrderMetrics;
      break;
    }

    case Actions.GET_SUPER_ADMIN_DASHBOARD_SALES_METRICS_LIST: {
        draft.superAdminDashboardSalesMetrics = payload?.superAdminDashboardSalesMetrics;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default superAdminDashboard;
